module.exports = __webpack_public_path__ + "img/devices.c6c54d02.png";